export interface CanvasPosition {
  x: number;
  y: number;
}

export const DEFAULT_CANVAS_POSITION: CanvasPosition = { x: 0, y: 0 };

export const normalizeCanvasPosition = (value: unknown): CanvasPosition => {
  if (value && typeof value === "object") {
    const raw = value as { x?: unknown; y?: unknown };
    const x = typeof raw.x === "number" ? raw.x : Number(raw.x);
    const y = typeof raw.y === "number" ? raw.y : Number(raw.y);
    return {
      x: Number.isFinite(x) ? x : DEFAULT_CANVAS_POSITION.x,
      y: Number.isFinite(y) ? y : DEFAULT_CANVAS_POSITION.y,
    };
  }

  return { ...DEFAULT_CANVAS_POSITION };
};

/** Below this px delta, a node move is treated as unchanged (avoids float-noise dirty flags). */
export const COORDINATE_EPSILON = 0.05;

/**
 * True when a node's new position differs meaningfully from its previously-saved one. Shared by
 * the RDV and Data Mart workspaces to detect unsaved layout changes (previously duplicated
 * byte-for-byte in both).
 */
export const hasCoordinateChanged = (
  next: CanvasPosition,
  previous: CanvasPosition | undefined
): boolean => {
  if (!previous) {
    return true;
  }
  return (
    Math.abs(next.x - previous.x) > COORDINATE_EPSILON ||
    Math.abs(next.y - previous.y) > COORDINATE_EPSILON
  );
};
